import React, { useState, useEffect } from "react";
import "../../assets/css/math-balloon-pop.css";
import MathBalloonPopMeta from "../../metas/math_balloon_pop";

function getQuestion() {
  const a = Math.floor(Math.random() * 10) + 1;
  const b = Math.floor(Math.random() * 10) + 1;
  const answer = a + b;
  const options = [answer];
  while (options.length < 4) {
    const fake = Math.floor(Math.random() * 20) + 1;
    if (!options.includes(fake)) options.push(fake);
  }
  return {
    question: `${a} + ${b}`,
    answer,
    options: options.sort(() => Math.random() - 0.5),
  };
}

const balloonSlots = ["10%", "30%", "50%", "70%"];

const MathBalloonPop = () => {
  const [q, setQ] = useState(getQuestion());
  const [score, setScore] = useState(0);
  const [lives, setLives] = useState(3);
  const [gameOver, setGameOver] = useState(false);
  const [balloons, setBalloons] = useState([]);
  const [wrongId, setWrongId] = useState(null);

  useEffect(() => {
    if (!gameOver) {
      spawnBalloons();
      const interval = setInterval(spawnBalloons, 6000);
      return () => clearInterval(interval);
    }
  }, [q, gameOver]);

  const spawnBalloons = () => {
    const shuffled = [...balloonSlots].sort(() => Math.random() - 0.5);
    const newBalloons = q.options.map((opt, idx) => ({
      id: Date.now() + idx,
      value: opt,
      left: shuffled[idx],
    }));
    setBalloons(newBalloons);
  };

  const handlePop = (value, id) => {
    if (value === q.answer) {
      setScore((prev) => prev + 1);
      setQ(getQuestion());
    } else {
      setWrongId(id);
      setTimeout(() => {
        setWrongId(null);
        setLives((prev) => {
          const newLives = prev - 1;
          if (newLives === 0) {
            setGameOver(true);
          }
          return newLives;
        });
        setQ(getQuestion());
      }, 500);
    }
  };

  const resetGame = () => {
    setScore(0);
    setLives(3);
    setGameOver(false);
    setQ(getQuestion());
  };

  return (
    <>
      <MathBalloonPopMeta />
      <div className="breadcrumbs" data-aos="fade-in">
        <div className="container">
          <h2> Math Balloon Pop</h2>
          <p>Sharpen your math skills by popping the correct balloon! </p>
        </div>
      </div>
      <div className="game-container">
        <div className="game-box">
          <div className="game-info">
            <h2 className="title">🎈 Pop the correct balloon!</h2>
            {!gameOver && <p className="question">What is {q.question}?</p>}
          </div>

          {!gameOver && (
            <div className="balloons-row">
              {balloons.map((b) => (
                <button
                  key={b.id}
                  onClick={() => handlePop(b.value, b.id)}
                  className={`balloon ${wrongId === b.id ? "shake" : ""}`}
                >
                  {b.value}
                </button>
              ))}
            </div>
          )}

          <div className="status">
            {gameOver ? (
              <>
                <h2 className="game-over">💥 Game Over!</h2>
                <p className="score-text">Your Score: {score}</p>
                <button onClick={resetGame} className="restart-btn">
                  Restart
                </button>
              </>
            ) : (
              <div className="score-lives">
                ⭐ Score: {score} | ❤️ Lives: {lives}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MathBalloonPop;
